/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

import { ENavigationPath } from 'constants/path';

const shouldUseCentralizedRedirectUri =
  process.env.REACT_APP_AUTH_SHOULD_USE_CENTRALIZED_REDIRECT_URI === 'true';

const loginRedirectUri: string = shouldUseCentralizedRedirectUri
  ? (process.env.REACT_APP_AZURE_AD_REDIRECT_URI as string)
  : `${window.location.origin}${ENavigationPath.AUTH_CALLBACK}`;

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID as string,
    authority: ('https://login.microsoftonline.com/' +
      process.env.REACT_APP_AZURE_AD_TENANT_ID) as string,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 300, // 5 minutes before token expiry
    allowNativeBroker: false,
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const loginRequest = {
  scopes: [
    `api://pinnacle-backend-${process.env.REACT_APP_PINNACLE_ENVIRONMENT}/pupaccess.new`,
  ],
};

export {
  loginRedirectUri,
  msalConfig,
  loginRequest,
  shouldUseCentralizedRedirectUri,
};
